import { useMutation } from '@tanstack/react-query';
import { deleteCard } from '../requests';

type Options = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

type DeleteCardVariables = {
  templateId: string;
};

export function useDeleteCard({ onSuccess, onError }: Options) {
  const mutation = useMutation<void, Error, DeleteCardVariables>({
    mutationFn: ({ templateId }) => deleteCard(templateId),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
